import { useToast } from "vue-toast-notification";

const NOTIFICATION_DURATION = 5000;

const SVG_SUCCESS = `<svg xmlns="http://www.w3.org/2000/svg" width="18.2" height="13" viewBox="0 0 49 34"><path fill="#00a489" d="M42.5 1.55a3.5 3.5 0 0 1 5.14 4.75l-.14.15-25.57 26a3.5 3.5 0 0 1-4.84.15l-.15-.15L1.5 16.75a3.5 3.5 0 0 1 4.85-5.05l.15.14 12.94 13.17L42.5 1.55z"/></svg>`;
const SVG_ERROR = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="#e74c3c" fill-rule="evenodd" d="M1 12c0 6.065 4.934 11 10.998 11 6.069 0 11.004-4.934 11.004-11S18.067 1 11.998 1C5.934 1 1 5.935 1 12Zm1.886 0c0-5.024 4.09-9.114 9.112-9.114 5.028 0 9.118 4.09 9.118 9.114 0 5.025-4.09 9.114-9.118 9.114-5.022 0-9.112-4.09-9.112-9.114ZM16.99 7.006a.944.944 0 0 0-1.266-.061l-.068.06-3.659 3.66-3.657-3.659-.067-.06a.944.944 0 0 0-1.267.06l-.06.067a.944.944 0 0 0 .06 1.267l3.658 3.658-3.658 3.658-.06.068a.944.944 0 0 0 .06 1.266l.068.06c.37.306.92.286 1.266-.06l3.657-3.659 3.659 3.659.067.06c.37.306.92.286 1.266-.06l.061-.067a.944.944 0 0 0-.06-1.267l-3.66-3.658 3.66-3.659.06-.067a.944.944 0 0 0-.06-1.266Z" clip-rule="evenodd"/></svg>`;

const NotificationService = {
  success(message) {
    NotificationService.notify(
      `<span class="v-toast__custom-icon">${SVG_SUCCESS}</span><span>${message}</span>`,
      {
        type: "success"
      }
    );
  },

  error(message) {
    NotificationService.notify(
      `<span class="v-toast__custom-icon">${SVG_ERROR}</span><span>${message}</span>`,
      {
        type: "error"
      }
    );
  },

  notify(message, options) {
    const defaultOptions = {
      type: "success",
      duration: NOTIFICATION_DURATION,
      message: message ?? "",
      position: "bottom"
    };

    useToast().open({
      ...defaultOptions,
      ...options
    });
  }
};

export default NotificationService;
